<template>
  
  <!-- 
    <Reply :name="quote.name" :text="qoute.text"/>
  -->
        <div class="row" style="justify-content: space-between; width: 100%;  padding: 8px 10px 5px">
          <div class="row" style="width: 100%;">
            <div class="column" style="margin-right: 16px; margin-top: 4px;">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.5 9.15L7.43745 1.5V5.75C17.5761 5.75 18.7457 13.9763 18.4641 18.5C18.0383 16.2178 17.8407 12.55 7.43745 12.55V16.8L1.5 9.15Z" stroke="#057AFF" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>
            </div>
            <div class="column">
              <p class="demi">Reply to {{ name }}</p>
              <p class="desc" :title="text">{{ tools.cut( text, 50)}}</p>
            </div>
          </div>
          <div class="column ch pointer click hover" @click="$emit('delete',true)" style="width: 24px; height: 24px; font-size: 18px; line-height: 18px; border-radius: 100px;">×</div>                    
        </div>

</template>
<script setup>
</script>
<script>
/* eslint-disable */
import { defineComponent } from 'vue';
export default defineComponent({
  mounted() {      
  //  
  },  
  props:{
    name: undefined,
    text: undefined,
  },
  data() {
    return {    
     

    }
  },

  methods: {
   
  },
 
});

</script>
<style scoped>
.container{
   /* width: 380px;  */
   /* height: 100%;  */
   border-radius: 20px; 
   background-color: var(--g05);   
}
.messageBox{
  position: relative; 
  align-self: flex-end; 
  overflow-y: scroll; 
  width: 380px; 
  height: 100%; 
  transform: scale(1,-1); 
}
.messageList{
  padding: 15px; 
  padding-bottom: 60px; 
  transform: scale(1,1);
}
.inputBox{
  position: relative; 
  border-bottom-left-radius: 20px; 
  border-bottom-right-radius: 20px; 
  bottom: 0; 
  width: 100%;
  background-color: #1C1C1C;
}
</style>